import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TablesState } from '../../types/tables';

const initialState: TablesState = {
  areas: [],
  tables: [],
  selectedAreaId: null,
  selectedTableId: null,
  loading: false,
  error: null,
};

export const tablesSlice = createSlice({
  name: 'tables',
  initialState,
  reducers: {
    setSelectedArea: (state, action: PayloadAction<string | null>) => {
      state.selectedAreaId = action.payload;
      state.selectedTableId = null; // Clear table selection when area changes
    },
    setSelectedTable: (state, action: PayloadAction<string | null>) => {
      state.selectedTableId = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { 
  setSelectedArea, 
  setSelectedTable, 
  clearError, 
  setLoading 
} = tablesSlice.actions;

export default tablesSlice.reducer;